import UiResource from './UiResource'
import { store } from '@/store/store'

class CustomConfigResource extends UiResource {
    async get(componentCode, laboratoryId = store.getters.labId) {
        try {
            const params = { laboratoryId }
            const response = await this.axios.get(`/uicomponents/${componentCode}/customconfigs`, { params })
            return response.data
        } catch (e) {
            if (e.response && e.response.status === 404) {
                return null
            }
            throw e
        }
    }
    async save(componentCode, config, laboratoryId = store.getters.labId) {
        const params = { laboratoryId }
        const currentConfig = await this.get(componentCode, laboratoryId)
        if (currentConfig) {
            return this.axios.put(`/uicomponents/${componentCode}/customconfigs/${currentConfig.id}`, { config }, { params }).then(response => response.data)
        }
        return this.axios.post(`/uicomponents/${componentCode}/customconfigs`, { config }, { params }).then(response => response.data)
    }
}

export default new CustomConfigResource()
